import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import * as dayjs from 'dayjs';
import { Subscription, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { ConfigService } from './json-config.service';
import { LOCAL_STORAGE_KEYS, LocalStorageService } from './local-storage.service';
import { LoggerService } from './logger/logger.service';
import { LogoutService } from './logout.service';
import { UserService } from './user/user.service';
import { NativeCheckService } from './native-check.service';

@Injectable({
  providedIn: 'root'
})
export class TimeoutLogoutService {
  private timerSubscription?: Subscription;

  public constructor(
    private router: Router,
    private configService: ConfigService,
    private logoutService: LogoutService,
    private userService: UserService,
    private localStorageService: LocalStorageService,
    private loggerService: LoggerService,
    private nativeCheckService: NativeCheckService,
  ) { }

  public initIdleTimeoutLogout(): void {
    this.checkInactiveReloadAsync();

    // todo optimize/debounce this?
    // todo - add some service for window watchers - issues/127
    window.addEventListener('click', this.refreshTimer.bind(this));
    window.addEventListener('scroll', this.refreshTimer.bind(this));

    this.router.events.subscribe((val) => {
        if (val instanceof NavigationStart) {
          this.refreshTimer();
        }
    });
  }

  private checkInactiveReloadAsync(): void {
    this.localStorageService.getItem({key: LOCAL_STORAGE_KEYS.LOCAL_STORAGE_TIMER_KEY}).pipe(take(1)).subscribe({
      error: this.checkInactiveReloadError.bind(this),
      next: this.checkInactiveReload.bind(this),
    });
  }

  private checkInactiveReloadError(error: unknown): void {
    this.loggerService.error(typeof error === 'function' ? error() : error);
  }

  private checkInactiveReload(date: string): void {
    const now = dayjs();

    if(
      date &&
      date.length &&
      now.diff(date, 'minutes') >= this.configService.getConfig(EnvironmentKeys.logoutAfterIdleForMinutes)
    ) {
      this.logoutService.logOut({withMessage: 'idleLogoutMessage'});
    }
  }

  public refreshTimer(): void {
    if(!this.userService.loggedUser) {
      this.localStorageService.deleteItemSync({ key: LOCAL_STORAGE_KEYS.LOCAL_STORAGE_TIMER_KEY });
      return;
    }

    this.localStorageService.setItem({
      key: LOCAL_STORAGE_KEYS.LOCAL_STORAGE_TIMER_KEY,
      value: dayjs().format()
    });

    const timeInMs = this.configService.getConfig(EnvironmentKeys.logoutAfterIdleForMinutes) * 60000;

    if (this.timerSubscription && !this.timerSubscription.closed) {
      this.timerSubscription.unsubscribe();
    }

    if(!this.nativeCheckService.isNativePlatform()) {
      this.timerSubscription = timer(timeInMs).subscribe(() => {
        this.logoutService.logOut({withMessage: 'idleLogoutMessage'});
      });
    }
  }
}
